const CAP_BITCOIN_BLOCK_HEIGHT = {
  title: "La Altura del Bloque",
  sections: [
    {
      heading: "¿Qué es la altura del bloque?",
      text: [
        "La altura del bloque (block height) es un número entero que indica la posición de un bloque dentro de una blockchain. Cada vez que se añade un nuevo bloque válido a la cadena, la altura aumenta en una unidad.",
        "Al navegar en un explorador de bloques, es posible buscar un bloque específico utilizando su altura. Esto facilita revisar transacciones, tiempos de minado y demás datos técnicos registrados en la cadena."
      ],
      bluepoint: [
        " **Definición básica:** la altura del bloque es el número que indica cuántos bloques se han añadido desde el Bloque Génesis.",
        " **Numeración secuencial:** cada nuevo bloque incrementa la altura en 1 (0, 1, 2, 3, …).",
        " **Navegación en exploradores:** la altura permite encontrar y analizar datos de un bloque concreto sin conocer su hash.",
        " **Relación con la historia de la red:** una altura mayor implica una cadena más larga y con más tiempo de funcionamiento.",
        " **Uso en diferentes redes:** Bitcoin, Ethereum, Litecoin y otras blockchains utilizan el concepto de altura de bloque."
      ]
    },
    {
      heading: "Bloque Génesis y crecimiento de la cadena",
      text: [
        "El primer bloque de la blockchain se conoce como Bloque Génesis y siempre tiene altura 0. A partir de este bloque inicial, cada nuevo bloque se enlaza criptográficamente con el anterior, formando una cadena ininterrumpida.",
        "En redes como Bitcoin, los bloques se generan aproximadamente cada 10 minutos, lo que hace que la altura de bloque esté en constante aumento. Otras redes pueden tener tiempos de bloque más cortos o más largos, según su diseño."
      ],
      bluepoint: [
        " **Bloque Génesis (altura 0):** marca el inicio oficial de la blockchain.",
        " **Enlazado criptográfico:** cada bloque incluye el hash del bloque anterior, asegurando integridad y continuidad.",
        " **Altura en constante cambio:** en Bitcoin se mina un bloque nuevo aproximadamente cada 10 minutos.",
        " **Otras redes:** en Ethereum o Litecoin la altura también cambia con cada bloque minado, aunque el tiempo entre bloques es diferente.",
        " **Registro histórico:** la combinación de altura + marca de tiempo permite reconstruir la línea de tiempo de la red."
      ]
    },
    {
      heading: "Altura de bloque, confirmaciones y seguridad",
      text: [
        "La altura de bloque también se usa para estimar la seguridad de una transacción. Cuando una transacción se incluye en un bloque, cada bloque posterior suma una confirmación. Cuantas más confirmaciones tiene, más difícil es revertirla.",
        "Además, algunas funciones avanzadas como los TimeLock permiten bloquear el uso de bitcoins hasta que se alcance una altura de bloque específica. Por último, aunque dos bloques distintos pueden tener la misma altura en situaciones de competencia entre mineros, la verdadera identidad de un bloque la define su hash, no solo su altura."
      ],
      bluepoint: [
        " **Confirmaciones:** si tu transacción está en el bloque N y la red va en el bloque N+6, entonces tiene 6 confirmaciones.",
        " **Más confirmaciones = más seguridad:** revertir una transacción con muchas confirmaciones requiere rehacer gran parte del trabajo de minado.",
        " **TimeLock por altura:** se pueden crear condiciones que solo permitan gastar fondos a partir de cierta altura de bloque.",
        " **Bloques competidores:** dos mineros pueden encontrar bloques distintos con la misma altura; la red solo conservará uno y el otro se descartará (orphan/stale block).",
        " **Hash del bloque:** el identificador clave de un bloque es su hash de encabezado; la altura es útil, pero no es un identificador único."
      ]
    }
  ]
};

export default CAP_BITCOIN_BLOCK_HEIGHT;
